import { isServer, isDevelopment } from '@/utils/helpers';

export const logYandexAnalytic = (targetName) => {
  if (isServer || isDevelopment) {
    return;
  }

  window.ym('56034880', 'reachGoal', targetName);
};
